<template>

  <el-pagination
   ref="pagination"
    :background="showBackground"
    :layout="pageData.total > pageData.per_page ? 'prev, pager, jumper, next, total' : 'total'"

    @prev-click="loadPage('prev')"
    @next-click="loadPage('next')"
    @current-change="onChangePage"

    :hide-on-single-page="hideOnSinglePage"
    :pager-count="pageCount"
    :total="pageData.total"
    :page-count="pageData.last_page">

  </el-pagination>
</template>

<script>

import VuetablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin'

export default {
  mixins: [VuetablePaginationMixin],

  props: {
    showBackground: {
      type: Boolean,
      default: false
    },

    hideOnSinglePage: {
      type: Boolean,
      default: true
    },

    startingPage: {
      type: Number,
      default: 1
    },

    pageCount: {
      type: Number,
      default: 5
    }
  },

  methods: {
    totalPages () {
      return this.pageData.total
    },

    onChangePage (page) {
      this.page = page
      this.pageData.current_page = this.page
      this.$emit('change-page', this.page)
    },

    setPaginationData (data) {
      this.pageData = data
    }
  },

  data () {
    return {
      page: this.startingPage,
      pageData: {total: 0, current_page: 1}
    }
  }
}
</script>
